import { render, staticRenderFns } from "./EditTeam.vue?vue&type=template&id=53ee7c46&"
import script from "./EditTeam.vue?vue&type=script&lang=js&"
export * from "./EditTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53ee7c46')) {
      api.createRecord('53ee7c46', component.options)
    } else {
      api.reload('53ee7c46', component.options)
    }
    module.hot.accept("./EditTeam.vue?vue&type=template&id=53ee7c46&", function () {
      api.rerender('53ee7c46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/teams/Edit/EditTeam.vue"
export default component.exports